import React from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon } from 'antd';
import { Link } from 'react-router-dom';
import './ViaFooter.css';
import { useSelector } from 'react-redux';
import { ViaLogo, LogoLocations } from '../logo/ViaLogo';
import { selectSessionUser } from '../../state/ui/application/sessionUiReducer';
import {
  externalRoutes, legalRoutes, entryRoutes, documentationRoutes,
} from '../../utility/route-locations';
import DownloadApp from '../../sections/secured/dashboard/components/DownloadApp';
import { asViaUrl } from '../../utility/via-fetch';
import {isPurCoInstall} from "../../configWeb";


function LinkList({ title, children }) {
  const createLink = (link, key) => <li key={key}>{link}</li>;

  return (
    <div className="footer-group">
      <h3 className="footer-group-title">{title}</h3>
      <ul className="footer-group-list">
        { children.map ? children.map((link, i) => createLink(link, i)) : createLink(children, 0) }
      </ul>
    </div>
  );
}

LinkList.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};


export default function ViaFooter() {
  const intl = useIntl();
  const sessionUser = useSelector(selectSessionUser);

  return (
    <footer className="via-footer">
      <div className="footer-primary">
        <p style={{ marginBottom: '0' }}><FormattedMessage id="footerMessage" /></p>
        <DownloadApp />
      </div>
      <div className="footer-secondary">
        <div className="via-centre footer-details">
          <LinkList title={intl.formatMessage({ id: 'legalDocuments' })}>
            <a href={asViaUrl(legalRoutes.privacy_policy)} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="privacyPolicy" />
            </a>

            <a href={asViaUrl(legalRoutes.terms_of_use)} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="termsOfUse" />
            </a>
            <a href={asViaUrl(legalRoutes.eula)} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="endUserLicence" />
            </a>
          </LinkList>
          <LinkList title={intl.formatMessage({ id: 'support' })}>
            {(sessionUser
              ? <Link to={entryRoutes.contactUs}><FormattedMessage id="contactUs" /></Link>
              : <Link to={entryRoutes.contactUsExternal}><FormattedMessage id="contactUs" /></Link>)}
            <Link to={documentationRoutes.user_guide} target="_blank"><FormattedMessage id="userGuide" /></Link>
          </LinkList>
          <LinkList title={intl.formatMessage({ id: 'followUs' })}>
            {isPurCoInstall() ? <></> : (
                < a href={externalRoutes.twitter} target="_blank" rel="noopener noreferrer">
              <Icon type="twitter" style={{marginRight: '0.3em'}} />
              Twitter
              </a>)
            }
            <a href={externalRoutes.youtube} target="_blank" rel="noopener noreferrer">
              <Icon type="youtube" style={{ fontSize: '1em', marginRight: '0.3em' }} />
              Youtube
            </a>
          </LinkList>
        </div>
      </div>
      <div className="footer-tertiary">
        <div className="via-centre footer-tertiary-contents">
          <ViaLogo className="via-footer-logo" href={isPurCoInstall() ? externalRoutes.purco : externalRoutes.moblyx} logoSrc={LogoLocations.MOBLYX_REVERSED_NORMAL_BLUE_CIRCLE_WHITE_M} />
          <div className="footer-copyright"><FormattedMessage id="copyright" /></div>
          <div />
        </div>
      </div>
    </footer>
  );
}
